import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isLoading: false
}

const slice = createSlice({
    name: 'loadingObserver',
    initialState,
    reducers: {
        setLoading: (state) => {
            return { ...state, isLoading: true }
        },
        setFinishLoading: (state) => {
            return { ...state, isLoading: false }
        },
    },
})

const { reducer, actions } = slice

export const { setLoading, setFinishLoading } = actions

export default reducer
